<!-- static content data from lang: device_management -->
<template>
    <div>
        <div class="h-100" v-loading="loading">
     <template v-if="errored">
         <div class="page-not">
           <Notfound />

          </div>
    </template>
    <template v-else>
            <base-header class="pb-6">
                <div class="row align-items-center pb-4">
                    <div class="col-lg-12 col-12">
                        <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.editHeaderTitle}}</h6>
                        <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                            <route-bread-crumb></route-bread-crumb>
                        </nav>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div>
                    <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <div class="col-md-12">
                      <template v-for="(message) in alertMessages">
                        <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                      </template>
                      <template v-for="(message) in successMessages">
                        <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                      </template>
                        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input :label="lang.label.siteName" name="site name" rules="required|max:50" labelClasses="form-control-label asterisk-mark">
                                                    <el-select v-model="model.CompanySitesID" autocomplete="off" :placeholder="lang.label.selectSite" filterable>
                                                        <el-option
                                                            v-for="(option,index) in siteList"
                                                            :key="index"
                                                            :label="option.Name"
                                                            :value="option.ID"

                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input
                                                    :label="lang.label.deviceName"
                                                    name="device name"
                                                    rules="required"
                                                    v-model="model.deviceName"
                                                    autocomplete="off"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input
                                                    :label="lang.label.deviceIdentifier"
                                                    name="device identifier"
                                                    rules="required"
                                                    v-model="model.deviceIdentifier"
                                                    autocomplete="off"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    ></base-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-right mb-3">
                                    <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                                    <base-button
                                        type="danger"
                                        @click="$router.push({name: 'deviceManagementList'})"
                                        >{{lang.label.buttons.cancel}}</base-button>
                                </div>
                            </form>
                        </validation-observer>
                    </div>
                    </card>
                </div>
            </div>
    </template>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import { Select, Option } from "element-ui";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import Alert from "@/components/BaseAlert.vue";
    import Notfound from "@/views/GeneralViews/NotFoundPage.vue";
    export default {
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            RouteBreadCrumb,
            Alert,
            Notfound
        },
        data() {
            return {
                ID: this.$route.params.id,
                lang: this.$lang.device_management,
                loading: true,
                 errored:false,
                model: {
                    siteName: "",
                    CompanySitesID: "",
                    deviceName: "",
                    deviceIdentifier: ""
                },
                selects: {
                    simple: "Select"
                },
                siteList: [],
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
            };
        },
        mounted() {
            this.getSiteList();
            let self = this;
            let id = this.ID;
            this.$store.dispatch('editDevice', id)
                    .then(response => {
                 if (response.status == 200) {
                        this.model.deviceName = response.data.Name;
                        this.model.CompanySitesID = response.data.CompanySitesID;
                        this.model.siteName = response.data.CompanySiteName;
                        this.model.deviceIdentifier = response.data.DeviceIdentifier;
                        this.loading = false;
                        }else {
                     if(response.status == 404){
                         this.errored = true;
                     }else{
                         if(typeof response.data.message != 'object'){
                             this.alertMessages.push(response.data.message);
                         }else{
                             let array = new Array();
                             for (let key of Object.keys(response.data.message)) {
                                 let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                 array.push(obj)
                             }
                             this.alertMessages.push(array.join(', '));
                             setTimeout(function () {
                                 self.alertMessages = [];
                             },5000)
                         }
                     }
                     this.loading = false;
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                    });
        },
        methods: {
            removeMessage(){
                let self = this;
                let timer = setTimeout(function () {
                    if(self.loading == false){
                        self.alertMessages = [];
                        clearTimeout(timer)
                    }
                },3000)
            },
            onSubmit() {
                let self = this;
                this.loading = true;
                let data = {
                    "id": this.ID,
                    "Name": this.model.deviceName,
                    "CompanySitesID": this.model.CompanySitesID,
                    "DeviceIdentifier": this.model.deviceIdentifier
                };
                this.$store.dispatch('updateDevice', data)

                        .then(response => {
                              if (response.status == 200) {
                             this.flash({message: response.data.message, variant: 'success'});
                            this.$router.push({name: "deviceManagementList"});
                            this.loading = false;
                         }else{
                                  if(typeof response.data.message != 'object'){
                                      this.alertMessages.push(response.data.message);
                                  }else{
                                      var array = new Array();
                                      for (let key of Object.keys(response.data.message)) {
                                          let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                          array.push(obj)
                                      }
                                      this.alertMessages.push(array.join(', '));
                                      setTimeout(function () {
                                          self.alertMessages = [];
                                      },5000)
                                  }
                                this.loading = false;
                      }
                        }).catch(error => {
                            this.loading = false;
                        })
            },
            getSiteList() {
                this.$store.dispatch("siteList").then(response => {
                    this.siteList = response.data;
                    this.loading = false;
                })
                        .catch(error => {

                        })
                        .finally(() => (this.loading = false));
            }
        }
    };
</script>
<style>
    .no-border-card .card-footer {
        border-top: 0;
    }
    .modal-header {
        padding-bottom: 0;
    }
</style>
